var React = require('react');

function DevCenter (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM1.1,0.7h6.5c4.1,0,7.4,3.3,7.3,7.4c-0.1,3.9-3.3,7.2-7.2,7.2l-6.6,0V0.7z","key":0}),React.createElement("path",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM10.3,5C8.7,3.4,6.2,3.4,4.6,5s-1.6,4.1,0,5.7s4.1,1.6,5.7,0L7.4,7.8L10.3,5z","key":1})]));
}

DevCenter.displayName = "DevCenter";

DevCenter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = DevCenter;

DevCenter.default = DevCenter;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/devCenter.svg
// module id = ../icon/src/icons/devCenter.svg
// module chunks = 0